// extracted by mini-css-extract-plugin
module.exports = {"registered":"Update_registered_u38D9"};